export default Object.freeze({
  Coordinate: 1,
  CanceledDE: 2,
});
